export default {
    'track.trackMap.h1':'达强竭诚为广大客户提供专业的一站式跨国运输服务。',
    'track.trackMap.p':'达强（深圳）国际物流有限公司（以下简称达强）是国内领先的多式贸易和物流联运公司。公司总部设在深圳；主要提供往返于亚洲、美洲和欧洲之间的综合完善的贸易和物流服务。    公司在中国(北京、深圳、香港)、俄罗斯、哈萨克斯坦、和乌克兰设有办事处；并在波兰、意大利和美国设有代理商。在中、美、欧以及独联体地区建立了完善的自营服务网点和代理网络。',
    'track.trackMap.more':'查看更多',
    'track.trackWay.russia.routerName':'俄罗斯运输线路',
    'track.trackWay.russia.transport.h2':'（俄罗斯运输线路空运 汽运 铁路）',
    'track.trackWay.russia.transport.p':'中国仓库 —— 机场 —— 莫斯科机场，圣彼得堡，新西伯利亚（或者转运其他城市）',
    'track.trackWay.russia.time.h3.01':'西线运输',
    'track.trackWay.russia.time.p1':'中国仓库 —— 口岸 —— 哈萨克斯坦 —— 莫斯科（或者转运其他城市）',
    'track.trackWay.russia.time.h3.02':'东线运输',
    'track.trackWay.russia.time.p2':'中国仓库 —— 口岸 —— 乌苏里斯克 —— 莫斯科（或者转运其他城市）',
    'track.trackWay.russia.time.h3.03':'铁路运输',
    'track.trackWay.russia.time.p3':'中国各仓库 —— 火车站 —— 莫斯科车站 —— 莫斯科仓库（或者转运其他城市）',
    'track.trackWay.russia.time.p4':'运输时效 18-25天（从收货日第二天算起） ',
    // 'track.trackWay.russia.pay.h3':'晚到赔偿',
    // 'track.trackWay.russia.pay.p1':'空运：如果发货后第13天还未到莫斯科市, 赔付0.1$/kg/天',
    // 'track.trackWay.russia.pay.p2':'陆运：如果发货后第25天还未到莫斯科市, 赔付5$/立方/天',
    'track.trackWay.uzbekistan.routerName':'乌兹别克斯坦运输线路',
    'track.trackWay.uzbekistan.h2':'乌兹别克斯坦运输线路（空运）',
    'track.trackWay.uzbekistan.h3':'可接：',
    'track.trackWay.uzbekistan.p.01':'1.普通货物',
    'track.trackWay.uzbekistan.p.02':'2.托盘货，超长，超高，超宽货物 （最大尺寸：600*244*297cm）',
    'track.trackWay.uzbekistan.p.03':'3.含电池货物，PI966/967/969/970 （例如：手机，蓝牙耳机，电动剃须刀等）',
    'track.trackWay.uzbekistan.p.04':'4.9610跨境电商产品 （例如：衣服，鞋子，包包，帽子，手机壳等）',
    'track.trackWay.uzbekistan.p.05':'5.粉末，液体货物（例如：化肥，农药，甲油胶等）',
    'track.trackWay.uzbekistan.p.06':'6.第9类危险品货物（例如：充电宝，纯电池，电子雾化器，平衡车等）',
    // 'track.trackWay.uzbekistan.pay.h3':'晚到赔偿',
    // 'track.trackWay.uzbekistan.pay.p.01':'空运：如果发货后第13天还未到塔什干, 赔付0.1$/kg/天',
    // 'track.trackWay.uzbekistan.pay.p.02':'陆运：如果发货后第25天还未到塔什干, 赔付5$/立方/天',
    'track.trackWay.kazakhstan.routerName':'哈萨克斯坦运输线路',
    'track.trackWay.kazakhstan.h2':'哈萨克斯坦运输线路（汽运 空运）',
    'track.trackWay.kazakhstan.p1':'陆运：中国仓库 —— 口岸 —— 阿拉木图（或者转运其他城市）时效10-15天',
    'track.trackWay.kazakhstan.p2':'空运：中国各大机场 —— 阿拉木图 时效5-7天（从收货日第二天算起）',
    // 'track.trackWay.kazakhstan.pay.h3':'晚到赔偿',
    // 'track.trackWay.kazakhstan.pay.p1':'空运：如果发货后第13天还未到阿拉木图, 赔付0.1$/kg/天',
    // 'track.trackWay.kazakhstan.pay.p2':'陆运：如果发货后第25天还未到阿拉木图, 赔付5$/立方/天',
    'track.trackWay.ukraine.routerName':'乌克兰运输线路',
    'track.trackWay.ukraine.h2':'乌克兰运输线路（空运 海运 铁路）',
    'track.trackWay.ukraine.list.p1':'海运：可接货物类型：普货、内置/配套电池产品、纯电、移动电源、脱毛仪、美容仪、轴承、发动机、机床、机器设备、滑板车等。时效：45-55天',
    'track.trackWay.ukraine.list.p2':'空运：可接货物类型：普货',
    'track.trackWay.ukraine.list.p3':'品牌货物 内置/配套电池产品 电子产品 电子雾化器等 时效：10-12天',
    'track.trackWay.ukraine.list.p4':'铁路：可接货物类型：普货、内置/配套电池产品、纯电、移动电源、脱毛仪、美容仪、轴承、发动机、机床、机器设备、滑板车等。 时效：35-40天',
    // 'track.trackWay.ukraine.pay.h3':'晚到赔偿',
    // 'track.trackWay.ukraine.pay.p1':'空运：如果发货后第13天还未到基辅, 赔付0.1$/kg/天 ',
    // 'track.trackWay.ukraine.pay.p2':'陆运：如果发货后第25天还未到基辅, 赔付5$/立方/天',
    'track.trackWay.belarus.routerName':'白俄罗斯运输线路',
    'track.trackWay.belarus.h2':'可到白俄罗斯运输达城市 白俄罗斯以及其他各大城市',
    // 'track.trackWay.belarus.pay.h3':'晚到赔偿',
    // 'track.trackWay.belarus.pay.p1':'空运：如果发货后第13天还未到明斯克, 赔付0.1$/kg/天',
    // 'track.trackWay.belarus.pay.p2':'陆运：如果发货后第25天还未到明斯克,赔付5$/立方/天',
    'track.trackWay.mongolia.routerName':'蒙古国运输线路',
    'track.trackWay.mongolia.h2':'蒙古国运输线路（汽运 空运 铁路）',
    'track.trackWay.mongolia.p1':'陆运：中国仓库 —— 口岸 —— 乌兰巴托（或者转运其他城市）',
    'track.trackWay.mongolia.p2':'空运：中国各大机场 —— 乌兰巴托',
    'track.trackWay.mongolia.p3':'铁路：中蒙铁路运输专线',
    'track.trackWay.mongolia.p4':'时效5-7天（从收货日第二天算起）',
    // 'track.trackWay.mongolia.pay.h3':'晚到赔偿',
    // 'track.trackWay.mongolia.pay.p1':'空运：如果发货后第13天还未到乌兰巴托, 赔付0.1$/kg/天 ',
    // 'track.trackWay.mongolia.pay.p2':'陆运：如果发货后第25天还未到乌兰巴托, 赔付5$/立方/天',
    'track.trackPancel.text01':'覆盖国家',
    'track.trackPancel.text02':'口岸和站点',
    'track.trackPancel.text03':'运输车辆',
    'track.trackPancel.text04':'正式员工',

}